<template>
  <div>
    <Header class="head" :height="40" :title="stockName+ '融资融券'"/>
    <div class="wrap">
      <h2 class="chart-title">两融余额图</h2>
      <QzqrChart
        v-if="innerCode"
        :innerCode="innerCode"
      />
      <div class="line"></div>
      <section class="sec-wrap">
        <h2 class="sec-title">个股融资融券交易数据</h2>
        <div style="padding: 6px 0">
          <p class="info-item">
            <span>融资余额</span>
            <span class="bold global_normal_text_color">{{tradingData.FinanceValue | formatUnit('亿')}}</span>
          </p>
          <p class="info-item">
            <span>融资较上日比</span>
            <span class="bold" :class="[{'global_rise_text_color': tradingData.FinanceValueDiff > 0},
                    {'global_fall_text_color': tradingData.FinanceValueDiff < 0},
                    {'global_normal_text_color': tradingData.FinanceValueDiff == 0}]
                  ">{{tradingData.FinanceValueDiff | formatUnit('亿')}}</span>
          </p>
          <p class="info-item">
            <span>融券余额</span>
            <span class="bold global_normal_text_color">{{tradingData.SecurityValue | formatUnit('亿')}}</span>
          </p>
          <p class="info-item">
            <span>融券较上日比</span>
            <span class="bold" :class="[
                      {'global_fall_text_color': tradingData.SecurityValueDiff < 0},
                      {'global_rise_text_color': tradingData.SecurityValueDiff > 0},
                      {'global_normal_text_color': tradingData.SecurityValueDiff == 0}]
                    ">{{tradingData.SecurityValueDiff | formatUnit('亿')}}</span>
          </p>
          <p class="info-item">
            <span>两融余额</span>
            <span class="bold global_normal_text_color">{{tradingData.FiSecuValue | formatUnit('亿')}}</span>
          </p>
          <p class="info-item">
            <span>融资余额占流通市值比</span>
            <span class="bold global_normal_text_color">{{(tradingData.FinaInTVRatio * 100).toFixed(2) + '%'}}</span>
          </p>
        </div>
      </section>
      <div class="line"></div>
      <div  v-if="list && list.length">
        <section class="sec-wrap">
          <h2 class="sec-title">历史两融买卖明细</h2>
          <table>
            <thead>
              <tr>
                <th class="cell-th" style="text-align:left;width:20%">日期</th>
                <th class="cell-th" style="text-align:right;">收盘价</th>
                <th class="cell-th" style="text-align:right;">涨跌幅</th>
                <th class="cell-th" style="text-align:right;">融资买入额</th>
                <th class="cell-th" style="text-align:right;">融资偿还额</th>
              </tr>
            </thead>
            <tbody>
              <tr class="cell-tr" v-for="(item, index) in list" :key="index">
                <td class="cell-td" style="text-align:left;width:20%">{{item.TradingDay | formatDate}}</td>
                <td class="cell-td bold" :style="{textAlign:'right',color: item.UpDownRatio === 0 ? '' : item.UpDownRatio > 0 ? '#d4332f' : '#258d01'}">{{item.ClosePrice ? item.ClosePrice.toFixed(2) : '--'}}</td>
                <td class="cell-td bold" :style="{textAlign:'right',color: item.UpDownRatio === 0 ? '' : item.UpDownRatio > 0 ? '#d4332f' : '#258d01'}">{{item.UpDownRatio | rate(true, false)}}</td>
                <td class="cell-td bold" style="text-align:right;">{{item.FinanceBuyValue |formatUnit('亿')}}</td>
                <td class="cell-td bold" style="text-align:right;">{{item.FinanceRefundValue |formatUnit}}</td>
              </tr>
            </tbody>
          </table>
        </section>
        <div class="more" @click="goStockRzrqList">查看更多 <img src="../../assets/icons/arrow-right.png"/></div>
      </div>
      <section class="sec-wrap" v-else >
        <h2 class="sec-title">历史两融买卖明细</h2>
        <img style="width:100%;height:auto" src="@/assets/no_data.png">
      </section>
    </div>
  </div>
</template>
<script>
import Header from '@/components/header.vue'
import QzqrChart from './chart/index.vue'
import {request} from '@/api/request'
import Utils from '@/utils/formatUnit'
import rate from '@/filters/rate'

export default {
  data() {
    return {
      innerCode: '',
      tradingData: {},
      list: []
    }
  },
  components: {
    QzqrChart,
    Header
  },
  filters: {
    formatUnit: Utils.formatUnit,
    rate,
    formatDate: function(val) {
      return val.substring(0, 10).replace(/-/g,'/')
    }
  },
  methods: {
    handleUrlParams() {
      let { stock ,innerCode }  = this.$route.params
      return {
        stockName: stock.split('-')[0],
        stockCode: stock.split('-')[1],
        innerCode
      }
    },
    async getTradingData() {
      const res = await request.get({
          url: request.apis.quote.query2IndividualStockFinaSecuTable,
          params: {InnerCode: this.innerCode}
      })
      this.tradingData = res || {}
    },
    async getHistoryTradeDetail() {
      const res = await request.get({
        url: request.apis.quote.query2TradingDetailTable,
        params: {pageSize:100, InnerCode: this.innerCode}
      })
      this.list = (res || []).slice(0,10)
    },
    goStockRzrqList() {
      this.$router.push({path:`/rzrq-stock-list.html?innerCode=${this.innerCode}&name=${this.stockName}`})
    }
  },
  async created() {
    let { stockName, stockCode, innerCode }  = this.handleUrlParams()
    this.stockName = stockName
    this.innerCode = innerCode
    this.getTradingData()
    this.getHistoryTradeDetail()
  }
}
</script>
<style lang="stylus" scoped>
  .head
    font-weight 500
    /deep/ p 
      font-size .17rem
  .wrap
    padding 40px 0 0
    background-color #fff
  .chart-title
    padding 12px 0 12px 12px
    color #333;
    font-size 18px
    line-height 25px
  .line
    height 6px
    background-color #F5F5F5
  .sec-wrap
    padding 0 12px
  .sec-title
    border-bottom 1px solid #EBEBEB
    padding 7px 0
    color #333
    font-size 16px
    font-weight bold
    line-height 22px
  .info-item
    display flex
    justify-content space-between
    align-items center
    line-height 26px
  .global_fall_text_color
    color #258d01
  .global_rise_text_color
    color #d4332f
  .global_normal_text_color
    color #333333
  .bold
    font-weight bold
  .cell-th
    font-weight unset
    width auto 
    font-size 13px
    color #999
    line-height 18px
  .cell-tr
    height .24rem
    line-height .24rem
  .cell-td
    width auto
    font-size 14px
    line-height 20px
    color #333
  .more
    height 40px
    border-top 1px solid #EBEBEB
    display flex
    justify-content center
    align-items center
    color #666666
    font-size 14px
    margin 10px 12px 20px
    cursor pointer
    img 
      width 6px
</style>